import { Box, Container, Flex, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Loader from '../../components/Loader';
import Subtitle from '../../components/Subtitle';
import Title from '../../components/Title';
import TitleContainer from '../../components/TitleContainer';
import { useValidatePhotoTokenQuery } from '../../gql/generated/graphql';

const PHOTO_SESSION_KEY = 'photo_session';

const PhotoCapture = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token');

  const { data, loading, error } = useValidatePhotoTokenQuery({
    variables: { token: token || '' },
    skip: !token,
  });

  const authToken = data?.validatePhotoToken?.authToken;

  useEffect(() => {
    if (authToken) {
      localStorage.setItem(PHOTO_SESSION_KEY, authToken);
    }
  }, [authToken]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Container textAlign="center">
        <TitleContainer>
          <Title>Unable to validate link</Title>
        </TitleContainer>
        <Subtitle>Please try again in a moment.</Subtitle>
      </Container>
    );
  }

  if (!token || !authToken) {
    return (
      <Container textAlign="center">
        <TitleContainer>
          <Title>This link has expired</Title>
        </TitleContainer>
        <Subtitle>Go back to your dashboard on your computer to get a new one.</Subtitle>
      </Container>
    );
  }

  return (
    <Container textAlign="center">
      <TitleContainer>
        <Title>Photo Capture</Title>
      </TitleContainer>
      <Subtitle>Your session is active.</Subtitle>
      <Flex justifyContent="center" mt={4}>
        <Box bg="gray.50" borderRadius="md" p={6}>
          <Text fontSize="sm" color="gray.600">
            Photo capture UI will be available here (LE-16008).
          </Text>
        </Box>
      </Flex>
    </Container>
  );
};

export default PhotoCapture;
